import React, { useState } from "react";
import { residential_val_data } from "../../data/valuationData";
import { PiPlayCircleLight } from "react-icons/pi";
import StampDutyValuationTab from "./ResidentialTab/StampDutyValuationTab";
import MortgageValuationTab from "./ResidentialTab/MortgageValuationTab";
import FamilyLawValuationTab from "./ResidentialTab/FamilyLawValuationTab";
import CapitalTaxValuationTab from "./ResidentialTab/CapitalTaxValuationTab";
import InsuraceValuationTab from "./ResidentialTab/InsuranceValuationTab";
import RentalValuationTab from "./ResidentialTab/RentalValuationTab";
import RetrospectiveValuationTab from "./ResidentialTab/RetrospectiveValuationTab";
import ProbateValuationTab from "./ResidentialTab/ProbateValuationTab";
import SettlementValuationtab from "./ResidentialTab/SettlementValuationTab";

const ResidentialValuationPage = () => {
  const [tabIndex, setTabIndex] = useState(0);
  const residentialValuationTab = (index) => {
    setTabIndex(index);
  };
  return (
    <div className="px-[5vw] sm:px-[10vw] xl:px-[15vw] flex flex-col items-center sm:flex-row pt-[120px] gap-5">
      <div className="h-auto">
        <h1 className="py-2 text-2xl lg:text-3xl font-playfair">
          {residential_val_data.title}
        </h1>
        <div className="py-5 flex flex-col lg:flex-row justify-center items-center gap-6 lg:gap-20">
          <div className="w-full lg:w-1/2 ">
            <img
              src={residential_val_data.image_url}
              alt=""
              className="w-full h-auto object-cover"
            />
          </div>

          <div className="w-full lg:w-1/2">
            <p className="pb-5">{residential_val_data.description}</p>
            <div className="flex flex-col md:flex-row gap-2 lg:gap-8 flex-1">
              {/* First Column: next 5 items */}
              <div className="space-y-2 flex-1">
                {residential_val_data.list_data
                  .slice(0, 5)
                  .map((item, index) => (
                    <div
                      key={index}
                      className="flex justify-start items-center gap-1 cursor-pointer hover:text-yellow"
                      onClick={() => residentialValuationTab(index)}
                    >
                      <PiPlayCircleLight className="text-[20px]" />{" "}
                      <span>{item}</span>
                    </div>
                  ))}
              </div>
              {/* Second Column: next 4 items */}
              <div className="space-y-2 flex-1">
                {residential_val_data.list_data
                  .slice(5, 9)
                  .map((item, index) => (
                    <div
                      key={index + 5}
                      className="flex justify-start items-center gap-1 cursor-pointer hover:text-yellow"
                      onClick={() => residentialValuationTab(index + 5)}
                    >
                      <PiPlayCircleLight className="text-[20px]" />{" "}
                      <span>{item}</span>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
        {/* Residential List Tab */}
        {tabIndex === 0 && <StampDutyValuationTab />}
        {tabIndex === 1 && <MortgageValuationTab />}
        {tabIndex === 2 && <FamilyLawValuationTab />}
        {tabIndex === 3 && <CapitalTaxValuationTab />}
        {tabIndex === 4 && <RetrospectiveValuationTab />}
        {tabIndex === 5 && <SettlementValuationtab />}
        {tabIndex === 6 && <ProbateValuationTab />}
        {tabIndex === 7 && <InsuraceValuationTab />}
        {tabIndex === 8 && <RentalValuationTab />}
       
      </div>
    </div>
  );
};

export default ResidentialValuationPage;
